import { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import { trackCtaClick } from "@/lib/analytics";

export function StickyMobileCTA() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    let observer: IntersectionObserver | undefined;
    const start = () => {
      const sentinel = document.getElementById("sticky-cta-sentinel");
      if (!sentinel || typeof IntersectionObserver === "undefined") return;
      observer = new IntersectionObserver(([entry]) => setShow(!entry?.isIntersecting));
      observer.observe(sentinel);
    };
    const requestIdle = window.requestIdleCallback ?? ((callback: IdleRequestCallback) => {
      return window.setTimeout(() => callback({ didTimeout: false, timeRemaining: () => 0 }), 600);
    });
    const cancelIdle = window.cancelIdleCallback ?? window.clearTimeout;
    const idleId = requestIdle(start, { timeout: 1000 });
    return () => {
      cancelIdle(idleId);
      observer?.disconnect();
    };
  }, []);

  return (
    <div
      className={cn(
        "fixed inset-x-0 bottom-0 z-40 border-t border-gold/20 bg-midnight/95 p-3 transition-transform duration-500 md:hidden",
        show ? "translate-y-0" : "translate-y-full",
      )}
    >
      <Button
        asChild
        className="h-12 w-full bg-gradient-gold text-base text-primary-foreground"
      >
        <a
          href="#inscricao"
          onClick={() =>
            trackCtaClick(
              "sticky_mobile",
              "Quero meu Sprint Code",
            )
          }
        >
          Quero meu Sprint Code
        </a>
      </Button>
    </div>
  );
}
